import React from "react";
import { fetchCurrentUserAndAccounts } from "api/users";
import { loadStoredAccountIds, findSelectedAccount } from "actions/bootstrap-actions";

export class AccountRedirector extends React.Component {
  componentWillMount() {
    return loadStoredAccountIds()
      .then(({ activeAccountId, favouriteAccountId }) => {
        fetchCurrentUserAndAccounts()
          .then(({ accounts }) => {
            const selectedAccount = findSelectedAccount(accounts, activeAccountId, favouriteAccountId);
            document.location.href = `/accounts/${selectedAccount.slug}/documents/all`;
          });
      });
  }
}



// WEBPACK FOOTER //
// ./src/js/containers/account-redirector.jsx